import React from "react";
import { auth } from "../Firebase";

import { Link } from "react-router-dom";
//Previous Code
//import { Link, Navigate } from "react-router-dom";
// import { Link as LinkScroll } from "react-scroll";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useAuth } from "./Context/AuthContext";

export default function Navbar() {
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      setLogin(false);
    } catch (error) {
      console.error(error.message);
    }
  };
  console.log(appUser);
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link className="navbar-brand text-center shadow" to="/">
            FITNESS JUNCTION
          </Link>
          <button
            className="navbar-toggler bg-light-subtle fs-6 px-2 "
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon  "></span>
          </button>
          <div className="collapse navbar-collapse " id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              {/* <li className="nav-item">
                <LinkScroll className="nav-link" to="scroll-to-exercises" spy={true} offset={50} duration={2000} >Exercises</LinkScroll>
                
              </li> */}
              <li className="nav-item">
                <Link className="nav-link" to="/fitness-tools">
                  Fit-Tools
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blogs">
                  Blogs
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/posts">
                  Posts
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/chat">
                  Community
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              {/* <LinkScroll className="nav-link" to="scroll-to-about-page" spy={true} offset={10} duration={2000} >About Us</LinkScroll> */}

              {isLogin ? (
                <li className="nav-item">
                  <NavDropdown
                    title={appUser.displayName}
                    className="profile-name"
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item
                      className="logout-btn"
                      onClick={handleLogout}
                    >
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>
              ) : (
                <>
                  <li className="nav-item profile-name">
                    <Link className="nav-link nav-register" to="/signup">
                      Register
                    </Link>
                  </li>
                </>
              )}

              {/* <li className="nav-item">
                <Link className="nav-link">About us</Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
